import Cookie from 'js-cookie';

export default {
    auth(to, from, next) {
        // const token = Cookie.get('token');
        const token = localStorage.getItem('token');

        if (!token) {
            next('/site');
        }
        console.log(token);

        next();
    },
}